<template>
    <button
        class="
            px-3 flex-center gap-1 text-won-green rounded border border-won-green py-1.5
            disabled:text-[#C2C4C6] disabled:border-[#C2C4C6] disabled:cursor-not-allowed
            text-base
        "
        :disabled="disabled"
        @click="copyShareLinkHandler"
    >
        <LinkIcon
            :class="buttonSize"
        />

        <span>Copy Link</span>
    </button>
</template>

<script setup>
import { useResumeShare } from "../../store/share-resume.store";
import { LinkIcon } from "@heroicons/vue/24/outline";

const props = defineProps({
    disabled: {
        type: Boolean,
        default: true
    },
	buttonSize: {
		type: String,
		default: 'size-6'
	}
})

const shareResumeStore = useResumeShare();

const copyShareLinkHandler = () => {
    shareResumeStore.copyLinkHandler(); 
}
</script>
